<script context="module">
  const colors = [
    'rgba(243, 61, 186, 0.4)','rgba(151, 227, 60, 0.4)','rgba(44, 24, 253, 0.4)','rgba(40, 56, 36, 0.4)','rgba(184, 205, 135, 0.4)',
    'rgba(13, 251, 185, 0.4)','rgba(255, 25, 71, 0.4)','rgba(125, 164, 86, 0.4)','rgba(177, 26, 255, 0.4)','rgba(242, 73, 14, 0.4)',
    'rgba(164, 71, 123, 0.4)','rgba(255, 255, 0, 0.4)','rgba(7, 174, 255, 0.4)','rgba(255, 172, 189, 0.4)','rgba(0, 0, 0, 0.4)',
    'rgba(255, 200, 0, 0.4)','rgba(0, 52, 255, 0.4)','rgba(149, 165, 166, 0.5)'
  ]
</script>

<script>
  export let articles
  export let page
  export let offsetx
  export let offsety
  export let scale
  export let state
  export let moving
  
  let down = -1

  function add(index, article, to) {
    if (index === state.last) {
      state.add = false
      state.del = false
      state.last = -1
    } else {
      state.last = index
      if (!to.rubricParts.includes(article.id)) {
        to.rubricParts.push(article.id)
        // article.rubseq = rub.rubseq
        let rub = state.rub[index]
        let rtu = state.rub[state.index]
        // articles[index].rubseq = rub.rubseq
        rub.seq = rtu.seq
        // let ind = article.rubind
        let old = articles[rub.index]
        // article.rubind = state.index
        rub.index = state.index
        if (old) {
          // articles[ind].rubricParts = articles[ind].rubricParts.filter((val) => val !== article.id)
          old.rubricParts = old.rubricParts.filter((val) => val !== article.id)
        }
        articles = articles
        console.log(articles[state.index], old, article)
      }
    }
  }

  function del(index, article, from) {
    // rub.rubricParts.push(article.id)
    from.rubricParts = from.rubricParts.filter((val) => val !== article.id)
    let rub = state.rub[index]
    // articles[index].rubseq = false // TODO 0
    rub.seq = 0
    // articles[index].rubind = false
    rub.index = -1
    articles = articles
    state = state
    console.log(articles[state.index], article)
  }

  const long = (par) => {
    down = par
    setTimeout(() => {
      if (down === par) {
        console.log('long', par)
        state.add = false
        state.del = true
      }
    }, 1000)
  }
</script>

<div>
 {#if !moving}
  {#each articles as article, index}
    {@const rub = state.rub[index]}
    <!-- {JSON.stringify(article)} -->
    {#each article.groups as group, order}
      {#if +group.page === +page && !group.isIgnored}
        <div class="group"
            style:background-color={rub.seq ? colors[rub.seq%colors.length] : ''}
            style:top="{group.vpos*scale+offsety}px"
            style:left="{group.hpos*scale+offsetx}px"
            style:width="{group.width*scale}px"
            style:height="{group.height*scale}px"
        >
          {#if group.type === 'rubric'}
            {#if state.del && state.index === index}
              <span class="del1" on:mousedown|stopPropagation={() => {state.del = false}}> -{rub.seq} </span>
            {:else if state.add}
              <span class="add1"
                on:mousedown|stopPropagation={() => {state.add = false; state.last = -1}} 
                on:mouseup={() => down = -1}> 
                +{rub.seq}
              </span>
            {:else}
              <span class="add1" on:mousedown|stopPropagation={() => {state.add = true; state.num = rub.seq; state.index = index; long(index)}}> +{rub.seq} </span>
            {/if}
          {:else if state.add && order === 0 && !rub.enabled && rub.seq !== state.num}
            <span on:mousedown|stopPropagation={() => add(index, article, articles[state.index])}>
              {rub.seq ? '('+rub.seq+')' : index+1}
            </span>
          {:else if state.del && order === 0 && !rub.enabled}
            <span on:mousedown|stopPropagation={() => del(index, article, articles[state.index])}>
              {rub.seq ? '('+rub.seq+')' : ''}
            </span>
          {/if}
          <!-- {#if group.type === 'heading' || group.type === 'sub'}
            <span on:mousedown|stopPropagation={() => {console.log('span'); group.type === 'heading' ? group.type = 'sub': group.type = 'heading'}}>
              sub
            </span>
          {/if} -->
        </div>
      {/if}
    {/each}
  {/each}
{/if}  
</div>

<style>
  .add1 {
    background-color: green;
    z-index: 3;
  }

  .del1 {
    background-color: red;
    z-index: 3;
  }
</style>